<mat-toolbar class="header-content">
    <div class="header-title">
        <mat-icon>add</mat-icon>
        {{'trackers.addTracker'|translate}}
    </div>

    <lib-button icon="close" color="none" textColor="muted" (click)="cancel()"
        tooltip="{{'viewer.close'|translate}}"></lib-button>
</mat-toolbar>

<mat-dialog-content>
    <div class="kyd-row" *ngFor="let row of rows; let i = index">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{'form.name'|translate}}</mat-label>
            <input matInput [(ngModel)]="row.name" name="name-{{i}}">
        </mat-form-field>

        <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{'trackers.serial_number'|translate}}</mat-label>
            <input matInput [(ngModel)]="row.serial" name="serial-{{i}}">
        </mat-form-field>

        <lib-button icon="delete" color="none" textColor="danger" [disabled]="rows.length <= 1"
            tooltip="{{'datatable.delete'|translate}}" (click)="removeRow(i)"></lib-button>
    </div>

    <lib-button icon="add" color="none" textColor="primary" text="{{'trackers.add_another_kyd'|translate}}"
        (click)="addRow()" class="add-row-button"></lib-button>
</mat-dialog-content>

<mat-dialog-actions class="actions">
    <lib-button color="outline" (click)="cancel()" icon="close" text="{{'viewer.close' | translate}}"></lib-button>
    <lib-button [disabled]="saving" text="{{'viewer.save' | translate}}" color="primary" icon="save"
        (click)="save()"></lib-button>
</mat-dialog-actions>
